import { isAxiosError } from 'axios';

/**
 * The API returns validation and not-found failures as `{ message }` (GlobalExceptionHandler),
 * so prefer that over Axios' own generic message before falling back.
 */
export function getErrorMessage(error: unknown): string {
  if (isAxiosError(error) && error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'An unexpected error occurred';
}
